import React from "react";

export function JobSection({id,title,defaultOpen=false,children}) {
  // Native disclosure keeps forms mounted, so collapsing does not discard drafts.
  return <details id={id} className="banner-panel banner-job-section" open={defaultOpen}>
    <summary><h2>{title}</h2></summary>
    <div className="banner-section-content">{children}</div>
  </details>;
}

export function JobSectionLinks({sections}) {
  function reveal(event,id) {
    const section=document.getElementById(id);
    if(!section)return;
    event.preventDefault();section.open=true;
    section.querySelector("summary")?.focus({preventScroll:true});
    section.scrollIntoView?.({block:"start"});
  }
  return <nav className="banner-section-links" aria-label="Job sections"><span>Jump to section:</span>
    {sections.map(([id,title])=><a key={id} href={"#"+id} onClick={event=>reveal(event,id)}>{title}</a>)}
  </nav>;
}
